import HubWelcomeContent from '../../../shared/components/HubWelcomeContent';
import { AccountWelcomeDto } from '../../../shared/models/AccountModel';
import {
  defaultWelcomeContent,
  defaultWelcomeTitle,
} from '../../../shared/utils/defaultTexts';

export default function ViewWelcomeMessageForm({
  email,
  model,
  logoUrl,
  transcript,
}: {
  model: AccountWelcomeDto;
  logoUrl: string;
  transcript: string;
  email: string;
}) {
  return (
    <HubWelcomeContent
      content={model?.content || defaultWelcomeContent}
      logoUrl={logoUrl}
      title={model?.title || defaultWelcomeTitle}
      videoUrl={model?.video?.videoUrl}
      transcript={transcript}
      adminInfo={email ? { name: '', email } : undefined}
    />
  );
}
